export default __webpack_public_path__ + "b65014482700dc11a04b7320013edb57.png";